import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/frontend/releases/20260721132756/layouts/default.vue").then(m => m.default || m))
}